import React from 'react';
import { cn } from '../../../../utils/cn';
import { TriggerItem } from './triggerConstants';

interface TriggerCardsGridProps {
  groupedTriggers: Record<string, TriggerItem[]>;
  onTriggerSelect: (triggerId: string) => void;
  onSegmentChangeSelect?: () => void;
}

const TriggerCardsGrid: React.FC<TriggerCardsGridProps> = ({
  groupedTriggers,
  onTriggerSelect,
  onSegmentChangeSelect,
}) => {
  const triggers = groupedTriggers.triggers ?? [];
  const hasTriggers = triggers.length > 0;

  if (!hasTriggers) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">No triggers available.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl">
      <h2 className="text-md font-semibold text-foreground mb-4">
        Campaign trigger
      </h2>
      <p className="text-sm text-muted-foreground mb-6">
        Choose how this campaign is triggered.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {triggers.map((trigger) => {
          const Icon = trigger.icon;
          return (
            <button
              key={trigger.id}
              onClick={() => {
                onTriggerSelect(trigger.id);
                if (
                  trigger.id === 'attribute-segment' &&
                  onSegmentChangeSelect
                ) {
                  onSegmentChangeSelect();
                }
              }}
              disabled={!trigger.enabled}
              className={cn(
                'group relative p-6 bg-card rounded-xl border-2 border-border transition-all text-left',
                !trigger.enabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:shadow-lg hover:-translate-y-0.5 hover:border-border'
              )}
            >
              <div className="flex items-start gap-4">
                <div
                  className={cn(
                    'flex-shrink-0 w-14 h-14 rounded-xl flex items-center justify-center transition-colors bg-muted group-hover:bg-muted/80',
                    trigger.bgColor
                  )}
                >
                  <Icon
                    className={cn(
                      'w-7 h-7 transition-transform',
                      trigger.iconColor,
                      !trigger.enabled
                        ? 'text-muted-foreground'
                        : 'group-hover:scale-110'
                    )}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-foreground mb-2 text-base">
                    {trigger.name}
                  </h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {trigger.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TriggerCardsGrid;
